import axios from 'axios';
import { AccountInfo} from '@azure/msal-browser';
import {getToken} from '../functions/getToken';

const apiUrl = import.meta.env.VITE_API_ENDPOINT? import.meta.env.VITE_API_ENDPOINT: '';

const headers = {
    'Content-Type': 'application/json',
};

const getData = async (endpoint: string, accounts: AccountInfo[],
    $filter?: string) => {
    
    const {token, role} = getToken(accounts);
    return await axios.get(`${apiUrl}${endpoint}`, {
        headers: {...headers,
        Authorization: `Bearer ${token}`, 'X-MS-API-ROLE': role},
        params: {$filter},
    }).then((res)=> {
        return res.data;
    }).catch((err)=> {
        // const status = err.response.status;
        // if (status === 401) {
        //     location.replace(`${appUrl}/session-expired`);
        // }
        return err.response;
    });
}

const patchData = async (endpoint: string, data: object,
    accounts: AccountInfo[]) => {

    const {token, role} = getToken(accounts);
    return await axios.patch(`${apiUrl}${endpoint}`, {...data}, {
       headers: {
        Authorization: `Bearer ${token}`, 'X-MS-API-ROLE': role,
       }
    }).then((res)=> {
        return res.status;
    }).catch((err)=> {
        // const status = err.response.status;
        // if (status === 401) {
        //     location.replace(`${appUrl}/session-expired`);
        // }
        return err.response;
    });

}

const deleteData = async (endpoint: string, accounts: AccountInfo[]) => {

    const {token, role} = getToken(accounts);
    return await axios.delete(`${apiUrl}${endpoint}`, {
        headers: {...headers,
        Authorization: `Bearer ${token}`, 'X-MS-API-ROLE': role,}
    }).then((res)=> {
        return res.status;
    }).catch((err)=> {
        // const status = err.response.status;
        // if (status === 401) {
        //     location.replace(`${appUrl}/session-expired`);
        // }
        return err.response;
    });

}


const postData = async (endpoint: string, data: object,
    accounts: AccountInfo[]) => {

    const {token, role} = getToken(accounts);
    return await axios.post(`${apiUrl}${endpoint}`, {
        ...data,
     }, {
        headers: {
            ...headers,
            Authorization: `Bearer ${token}`, 'X-MS-API-ROLE': role
        }  
    }).then((res)=> res)
    .catch((err)=> {
        // const status = err.response.status;
        // if (status === 401) {
        //     location.replace(`${appUrl}/session-expired`);
        // }
        return err;
    });
}

export {getData, patchData, deleteData, postData};